export const RECOVERY_EVENT_STORAGE_KEY = "mgfood_pending_recovery_event";

const getStorage = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.sessionStorage;
};

const getConnection = () => {
  if (typeof navigator === "undefined") {
    return null;
  }

  return (
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection ||
    null
  );
};

export const isStandaloneRuntime = () => {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return Boolean(
      window.matchMedia?.("(display-mode: standalone)")?.matches ||
      window.navigator?.standalone === true,
    );
  } catch (_error) {
    return Boolean(window.navigator?.standalone === true);
  }
};

export const getRuntimeDiagnostics = () => {
  const connection = getConnection();

  return {
    online:
      typeof navigator !== "undefined" ? navigator.onLine : undefined,
    visibilityState:
      typeof document !== "undefined" ? document.visibilityState : undefined,
    standalone: isStandaloneRuntime(),
    referrer:
      typeof document !== "undefined" ? document.referrer || undefined : undefined,
    viewport:
      typeof window !== "undefined"
        ? `${window.innerWidth}x${window.innerHeight}`
        : undefined,
    connection: connection
      ? {
          effectiveType: connection.effectiveType,
          downlink: connection.downlink,
          rtt: connection.rtt,
          saveData: connection.saveData,
        }
      : undefined,
    deviceMemory:
      typeof navigator !== "undefined" ? navigator.deviceMemory : undefined,
    hardwareConcurrency:
      typeof navigator !== "undefined"
        ? navigator.hardwareConcurrency
        : undefined,
  };
};

export const createDiagnosticId = (prefix = "diag") => {
  const randomPart =
    globalThis.crypto?.randomUUID?.() ||
    `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

  return `${prefix}-${randomPart}`;
};

export const persistPendingRecoveryEvent = (payload) => {
  try {
    getStorage()?.setItem(
      RECOVERY_EVENT_STORAGE_KEY,
      JSON.stringify({
        ...payload,
        recordedAt: new Date().toISOString(),
      }),
    );
  } catch (_error) {
    // Ignore storage failures to avoid breaking recovery.
  }
};

export const consumePendingRecoveryEvent = () => {
  const storage = getStorage();

  if (!storage) {
    return null;
  }

  try {
    const rawEvent = storage.getItem(RECOVERY_EVENT_STORAGE_KEY);
    storage.removeItem(RECOVERY_EVENT_STORAGE_KEY);

    return rawEvent ? JSON.parse(rawEvent) : null;
  } catch (_error) {
    return null;
  }
};
